/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// import RouterTab and styles
import RouterTab from 'vue-router-tab/lib/index'
import 'vue-router-tab/dist/lib/vue-router-tab.css'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// Loading
import './components/Loading/index.css';
import Loading from './components/Loading/index';
Vue.use(Loading);

// Theme Configurations
import '../themeConfig.js'

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// 封装api访问等功能
import tools from './tools/index.js';
Vue.prototype.$tools = tools;


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')



//定义全局过滤器
import * as filters from './filter.js'; // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{
  ak:'F2rt33OHjRgewBrqGVE9eQgp'
})


// 打印
import Print from 'vue-print-nb'
// 注册
Vue.use(Print)

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import VTooltip from 'v-tooltip'
import './assets/scss/tooltip.scss'
Vue.use(VTooltip)

// VeeValidate
import VeeValidate, {Validator} from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import en from 'vee-validate/dist/locale/en';
    Vue.use(VeeValidate, {
        dictionary: {
          zh:zh_CN,
          en:en
        }
      })
Validator.localize(localStorage.getItem('locale'));
import   './validate.js'

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 


import Highchart from "highcharts/highcharts";
import stockInit from "highcharts/modules/stock";
import HighchartsVue from 'highcharts-vue'
import highchartsMore from 'highcharts/highcharts-more';
highchartsMore(Highchart);
stockInit(Highchart);
Vue.use(HighchartsVue)

Vue.mixin({
  methods: {
    arrayDateFormat(d) {
      return `${d[0]}-${d[1]}-${d[2]}  ${d[3]}:${d[4]}`;
    },
    getUser(accountNo){
      let userList=store.state.myUsers
      let user={}
      userList.forEach(u=>{
      if(accountNo==u.accountNo){
        user= u
      }
      })
      return user
    },
    getUsername(accountNo){
      let userList=store.state.myUsers
      let name=''
      userList.forEach(u=>{
      if(accountNo==u.accountNo){
        name= u.displayName
      }
      })
      return name
    },
    getYMDHMS(times) { // 把时间戳转换成时间 （YYYY-MM-DD HH:MM:SS）
      var time = new Date(times)
      var year = time.getFullYear()
      var month = (time.getMonth() + 1).toString().padStart(2,'0')
      var date = (time.getDate()).toString().padStart(2,'0')
      var hours = (time.getHours()).toString().padStart(2,'0')
      var minute = (time.getMinutes()).toString().padStart(2,'0')
      var second = (time.getSeconds()).toString().padStart(2,'0')
  
      return year + '-'+month +'-'+date + ' '+hours + ':'+minute + ':'+second
    }
  },
})


Vue.config.productionTip = false
Vue.use(RouterTab)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

import outTime from './longinTimeOut.js';
Vue.use(outTime)
